<div class="component-approach-wrap {{theme.colorSystem}}">
  <div class="approach-desc" *ngIf="isCamp">{{theme.desc}}</div>
  <div class="approach-label" *ngIf="!isCamp && !isTencent">
    <div *ngIf="isShowFull && !type">
      <div class="approach-label-item"
           *ngFor="let item of label;let i = index" [ngStyle]="{'width':  100/label.length + '%'}">
        <span>{{item}}</span> <span *ngIf="i<=theme.currentIndex">
        <img src="{{assetsRoute}}/picture/courselearning/check.png" alt="" *ngIf="!isFirst"/>
        <img src="{{assetsRoute}}/picture/courselearning/check.png" alt="" *ngIf="isFirst"
             [ngClass]="{'first-check':i==theme.currentIndex}"/>
      </span>
      </div>
      <div class="approach-progress">
        <div class="progress">
          <div class="progress-anchor progress-anchor-{{theme.currentIndex}}"></div>
          <div class="progress-mark"
               *ngFor="let item of label;let i = index" [ngStyle]="{'left': 100/label.length*i+'%'}"></div>
          <div class="progress-mark" *ngIf="theme.currentIndex === 3" [ngStyle]="{'left': 99+'%'}"></div>
          <div class="progress-inner" *ngIf="!isFirst" [ngStyle]="{'width': 100/label.length*(theme.currentIndex+1) +'%'}"></div>
          <div class="progress-inner first-progress-{{theme.currentIndex}}" *ngIf="isFirst"></div>
        </div>
      </div>
    </div>
    <!-- pc横版样式 -->
    <div class="style" *ngIf=" type === 'huatek'">
      <div class="common-back-btn-sight"  id="closeBtn"></div>
      <div class="approach-desc">{{theme.desc}}</div>
    </div>
    <div *ngIf="!type" class="approach-desc">{{theme.desc}}</div>
  </div>

  <div style="position: relative">
    <div class="noteIcon" *ngIf="theme.colorSystem === 'light'"></div>
    <component-btn *ngIf="!type"  [theme]="buttonTheme" [isDisabled]="false" (onCommit)="onGoCourse.emit()"></component-btn>
  </div>


</div>



// WEBPACK FOOTER //
// ./src/component/approach/components.approach.html